(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PracticeProfileDialogController', PracticeProfileDialogController);

    PracticeProfileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PracticeProfile'];

    function PracticeProfileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PracticeProfile) {
        var vm = this;

        vm.practiceProfile = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.practiceProfile.id !== null) {
                PracticeProfile.update(vm.practiceProfile, onSaveSuccess, onSaveError);
            } else {
                PracticeProfile.save(vm.practiceProfile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:practiceProfileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
